"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _axios = _interopRequireDefault(require("axios"));

var _Selector = _interopRequireDefault(require("../selector/Selector"));

var _UserAvatar = _interopRequireDefault(require("../User/UserAvatar"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var UserSelector = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(UserSelector, _Component);

  var _super = _createSuper(UserSelector);

  function UserSelector() {
    (0, _classCallCheck2.default)(this, UserSelector);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(UserSelector, [{
    key: "validateUser",
    value: function () {
      var _validateUser = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(userName) {
        var _this$props$excludeUs, _this$props$excludeUs2, _response$data;

        var response, normalizedInput, exactMatch;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _axios.default.get(this.props.url, {
                  params: {
                    query: userName,
                    excludeUsers: (_this$props$excludeUs = (_this$props$excludeUs2 = this.props.excludeUsers) === null || _this$props$excludeUs2 === void 0 ? void 0 : _this$props$excludeUs2.join(',')) !== null && _this$props$excludeUs !== void 0 ? _this$props$excludeUs : ''
                  }
                });

              case 2:
                response = _context.sent;

                if ((_response$data = response.data) !== null && _response$data !== void 0 && _response$data.length) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return", null);

              case 5:
                normalizedInput = userName.trim().toLowerCase();
                exactMatch = response.data.find(function (user) {
                  return user.name && user.name.toLowerCase() === normalizedInput;
                });
                return _context.abrupt("return", exactMatch !== null && exactMatch !== void 0 ? exactMatch : null);

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function validateUser(_x) {
        return _validateUser.apply(this, arguments);
      }

      return validateUser;
    }()
  }, {
    key: "baseUrl",
    value: function baseUrl() {
      var _this$props$searchAct = this.props.searchActiveUsersOnly,
          searchActiveUsersOnly = _this$props$searchAct === void 0 ? false : _this$props$searchAct;
      var excluded = '';

      if (this.props.excludeUsers) {
        excluded = this.props.excludeUsers.join(',');
      }

      return "".concat(this.props.url.split('?')[0], "?searchActiveUsersOnly=").concat(searchActiveUsersOnly ? '1' : '0', "&excludeUsers=").concat(excluded).concat(this.props.permission ? "&permission=".concat(this.props.permission) : '', "&query=");
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var props = this.props;
      return (0, _preact.h)("div", {
        className: "user-selector"
      }, (0, _preact.h)(_Selector.default, {
        initialItems: props.initialItems,
        placeholder: props.placeholder,
        config: {
          dynamic: {
            baseUrl: this.baseUrl(),
            omitItemsKey: 'id',
            dynamicItemElement: function dynamicItemElement(item) {
              return (0, _preact.h)(UserItem, {
                user: item
              });
            }
          },
          itemElement: function itemElement(item) {
            return (0, _preact.h)(UserItem, {
              user: item
            });
          },
          itemToStringKey: 'name',
          delimiter: ',',
          keys: {
            insert: ['Enter', 'Tab', ',', ';'],
            remove: ['Backspace']
          }
        },
        onValidate: /*#__PURE__*/function () {
          var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(value) {
            return _regenerator.default.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    _context2.next = 2;
                    return _this.validateUser(value);

                  case 2:
                    return _context2.abrupt("return", _context2.sent);

                  case 3:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2);
          }));

          return function (_x2) {
            return _ref.apply(this, arguments);
          };
        }(),
        onChange: function onChange(users) {
          return props.onChange(users);
        },
        error: props.error,
        customFetch: props.customFetch
      }));
    }
  }]);
  return UserSelector;
}(_preact.Component);

var UserItem = function UserItem(_ref2) {
  var user = _ref2.user;
  return (0, _preact.h)("div", {
    className: user.className
  }, user.id && (0, _preact.h)(_UserAvatar.default, {
    user: user
  }), (0, _preact.h)("span", null, user.name), user.descriptionSlot);
};

var _default = UserSelector;
exports.default = _default;